export const SYSTEM_CONFIG_MAPPING = {
    kly: {
        systemName: "客流芸管理系统",
        title: "客流芸管理系统(客流统计|客流去重|人流量统计|客流计数器)",
        isShowLogo: true,
    },
    klyTest: {
        systemName: "客流芸测试环境",
        title: "客流芸测试环境(客流统计|客流去重|人流量统计|客流计数器)",
        isShowLogo: true,
    },
    renjia: {
        systemName: "客流云管理系统",
        title: "客流云管理系统(客流统计|客流去重|人流量统计|客流计数器)",
        isShowLogo: false,
    },
    pavcn: {
        systemName: "派威客流管理系统",
        title: "派威客流管理系统(客流统计|客流去重|人流量统计|客流计数器)",
        isShowLogo: false,
    }
}

export const getCurrentSystemConfig = () => {
    const system = SYSTEM_CONFIG_MAPPING[window.currentSystemKey];
    return system || SYSTEM_CONFIG_MAPPING.kly;
}

/**
 * 微信渠道编号
 */
export const WX_CHANNEL_CODE = "wx_native";

/**
 * 通用子系统编码,不需要跳转的
 */
export const COMMON_SYSTEM_CODE_LIST = ["system", "kl", "erp", "camera"]
/**
 * 当前子系统编码
 */
export const CURRENT_SYSTEM_CODE = "kl";

/**
 * 配置信息
 */
export const CONFIG = {
    /**
     * 单价小数点精度
     */
    PRICE_PRECISION: "erp.price.precision",
    /**
     * 金额小数点精度
     */
    AMOUNT_PRECISION: "erp.amount.precision",

    /**
     * 库存数量小数点精度
     */
    STORAGE_NUMBER_PRECISON: "erp.storage.number.precision"
}